module.exports = __webpack_public_path__ + "static/media/404_Illustration.afe774e4.svg";